<template>
    <div id="barra-fija">
        <a href="/logout/" class="btn btn-primary pull-right">Cerrar Sesion</a>
        <div id="menu-principal">
            <form method="post" class="form-inline">
                <a href="/" id="logo-taco"></a>&nbsp;
                <router-link :to="{ name: 'home' }" class="btn btn-primary">Inicio</router-link>&nbsp;
                <span v-if="showBackButton">
                    <router-link :to="{ name: 'edit-order', id}" class="btn btn-primary">Volver</router-link>&nbsp;
                </span>
                <input type="button" class="btn btn-primary" @click="saveAndExport" value="Exportar" />&nbsp;
                <input type="button" class="btn btn-primary" @click="saveAndExportWithProvider" value="Exportar con Proveedor" />&nbsp;
                <input type="button" class="btn btn-primary" @click="saveExportAndSend" value="Enviar Pedido" />&nbsp;
                <input type="button" class="btn btn-primary" @click="totals" value="Totales" />&nbsp;
                <input type="text" name="analisis" id="analisis" class="form-control" v-model="title" />&nbsp;
                <input type="button" name="guardar" id="guardar" @click="save" class="btn btn-primary" value="Guardar" />&nbsp;
                <input type="button" class="btn btn-primary" @click="autoCompletar" value="Autocompletar" title="No se respetarán los valores minimos" />
                &nbsp;
                <div class="totales-x-proveedor" @click="toggleProvList">
                    <p>Totales por proveedor</p>
                    <ul class="lista-proveedores" v-show="showProvList">
                        <li v-for="(proveedor, index) in totalesPorProveedor" :key="index">{{proveedor.razonsocial}}: {{proveedor.total}}</li>
                    </ul>
                </div>
                <div class="clear"></div>
            </form>
        <div class="clear"></div>
        </div>
        <!-- <div id="clientes-activos">
        <div>C.A</div>
        </div> -->
    </div>
</template>

<script>
import { ref } from 'vue';
// import axios from 'axios';
import { useRoute } from 'vue-router'

export default {

    props: {"analisis": String, "totalesPorProveedor": Object},

    setup(props, context) {

        const route = useRoute();
        console.log( 'route: ', route.params.id )
        var showBackButton = false
        if( parseInt(route.params.id) ){
            showBackButton = true
        }

        const title = ref(props.analisis);
        const showProvList = ref(false);

        const totals = () => {
            // console.log('totales')
            context.emit("totals")
        }

        const save = () => {
            // console.log('save 1', title.value)
            context.emit("save", title.value)
        }

        const autoCompletar = () => {
            // console.log('autoCompletar')
            context.emit("autoCompletar")
        }

        const saveAndExport = () => {
            context.emit("saveAndExport")
        }

        const saveAndExportWithProvider = () => {
           context.emit("saveAndExportWithProvider") 
        }

        const saveExportAndSend = () => {
           context.emit("saveExportAndSend") 
        }

        const toggleProvList = () => {
            showProvList.value = !showProvList.value;
        }

        return {
            totals,
            save,
            toggleProvList,
            showProvList,
            autoCompletar,
            saveAndExport,
            saveAndExportWithProvider,
            saveExportAndSend,
            showBackButton,
            title,
            id: route.params.id,
        }
    },
}
</script>

<style scoped>
.totales-x-proveedor{
    display: inline-block;
    padding: 0;
    margin-top: 3px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    vertical-align: middle;
    cursor: pointer;
    position:relative;
    background:#fff;
    color:#000;
    width:12em;
    max-height:34px;
}
.totales-x-proveedor p{
    padding: 6px 6px 0;
}

ul, li{
    list-style: none;
    margin: 0;
    padding:0;
}
li{
    border-bottom: #ccc solid 1px;
    padding:3px;
}
.lista-proveedores{
    position:absolute;
    background:#fff;
    color:#000;
    width:100%;
}
</style>